export function LoadingDots(props: { className?: string }) {
  const { className } = props
  return (
    <div className={`flex items-start justify-start gap-x-3 my-3 ${className}`}>
      <div className='h-2 w-2 animate-dot1 rounded-full' />
      <div className='h-2 w-2 animate-dot2 rounded-full' />
      <div className='h-2 w-2 animate-dot3 rounded-full' />
    </div>
  )
}
